// Galleria95 multiplayer — Supabase Realtime presence + broadcast.
// Loaded only when window.VAPOR_MALL.multiplayer.enabled is true.
//
// Public API attached to window.Galleria95MP:
//   start(scene, floorKey)     — join the channel for this floor; called from MallFloorBase.create
//   stop()                      — leave channel (called when switching floors)
//   sendPosition(x, y, dir, anim) — broadcast our current state (called ~10Hz from update)
//   sendChat(text)             — broadcast a chat line (called from chat send handler)
//   onChat(cb)                 — register a chat receive callback
//   getRemotes()               — { id: { x, y, dir, anim, name, opts } } snapshot
//
// The actual rendering of remote-player sprites is done by vapor-mall-game.js
// (it owns Phaser); this module is purely the network layer.

(function () {
  if (window.Galleria95MP) return;

  var CONFIG = (window.VAPOR_MALL && window.VAPOR_MALL.multiplayer) || {};
  if (!CONFIG.enabled || !CONFIG.url || !CONFIG.anonKey) {
    // Multiplayer disabled or unconfigured — install a no-op stub so callers don't crash.
    window.Galleria95MP = {
      enabled: false,
      start: function () {}, stop: function () {},
      sendPosition: function () {}, sendChat: function () {},
      onChat: function () {}, getRemotes: function () { return {}; }
    };
    return;
  }

  // --- Identity (persisted in localStorage so the same player is recognized across reloads) ---
  function uid() {
    return 'g95-' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
  }
  function generateName() {
    var adj = ['Pink', 'Cyan', 'Neon', 'Vapor', 'Chrome', 'Velvet', 'Lonely', 'Quiet', 'Glitch', 'Static', 'Crystal', 'Holo', 'Plastic', 'Mall', 'Lost'];
    var noun = ['Wanderer', 'Shopper', 'Ghost', 'Drifter', 'Bystander', 'Visitor', 'Patron', 'Guest', 'Tourist', 'Stranger', 'Phantom'];
    return adj[Math.floor(Math.random() * adj.length)] + ' ' + noun[Math.floor(Math.random() * noun.length)] + ' #' + Math.floor(Math.random() * 9000 + 1000);
  }

  var myId = localStorage.getItem('g95-mp-id') || uid();
  localStorage.setItem('g95-mp-id', myId);

  var myName = localStorage.getItem('g95-mp-name') || generateName();
  localStorage.setItem('g95-mp-name', myName);

  // Pull avatar appearance from the same store the game uses
  function loadAvatarOpts() {
    try {
      var raw = localStorage.getItem('vapor-mall-avatar');
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  }

  // --- Supabase client (loaded via CDN script tag in the section/layout) ---
  if (!window.supabase || !window.supabase.createClient) {
    console.error('[Galleria95MP] Supabase SDK not loaded — add the CDN script tag before this file.');
    window.Galleria95MP = { enabled: false, start: function(){}, stop: function(){}, sendPosition: function(){}, sendChat: function(){}, onChat: function(){}, getRemotes: function(){return {};} };
    return;
  }
  var sb = window.supabase.createClient(CONFIG.url, CONFIG.anonKey, {
    realtime: { params: { eventsPerSecond: 20 } }
  });

  var channel = null;
  var channelReady = false;    // true once SUBSCRIBED — gates broadcast sends
  var currentFloorKey = null;
  var remotes = {};            // id -> { x, y, dir, anim, name, opts, lastSeen }
  var chatCallbacks = [];
  var lastPosSent = 0;
  var lastChatSent = 0;
  var POS_THROTTLE = 100;      // ms — 10 updates/sec
  var CHAT_RATE_LIMIT = 1000;  // ms — 1 chat per second per user

  // Tiny profanity filter — first-pass; users can extend
  var BLOCKED = ['fuck','shit','bitch','cunt','nigger','faggot','retard','rape'];
  function clean(text) {
    var t = String(text || '').slice(0, 200);
    BLOCKED.forEach(function (w) {
      var re = new RegExp('\\b' + w + '\\w*\\b', 'gi');
      t = t.replace(re, function (m) { return m.charAt(0) + new Array(m.length).join('*'); });
    });
    return t;
  }

  function start(floorKey) {
    if (channel && currentFloorKey === floorKey) return; // already on this channel
    if (channel) stop();
    currentFloorKey = floorKey;
    channelReady = false;
    remotes = {};

    var topic = 'galleria95:floor:' + floorKey;
    channel = sb.channel(topic, {
      config: {
        presence: { key: myId },
        broadcast: { self: false, ack: false }
      }
    });

    channel.on('presence', { event: 'sync' }, function () {
      var state = channel.presenceState();
      // Drop anyone who left
      Object.keys(remotes).forEach(function (id) {
        if (!state[id]) delete remotes[id];
      });
      Object.keys(state).forEach(function (id) {
        if (id === myId) return;
        var meta = state[id][0] || {};
        var r = remotes[id] || {};
        r.name = meta.name || r.name || 'Visitor';
        r.opts = meta.opts || r.opts || {};
        r.lastSeen = Date.now();
        if (typeof r.x !== 'number') { r.x = meta.spawnX || 0; r.y = meta.spawnY || 0; }
        r.dir = r.dir || 'down';
        r.anim = r.anim || 'idle';
        remotes[id] = r;
      });
    });

    channel.on('broadcast', { event: 'pos' }, function (msg) {
      var p = msg.payload || {};
      if (p.id === myId) return;
      var r = remotes[p.id] || {};
      r.x = p.x; r.y = p.y; r.dir = p.dir; r.anim = p.anim;
      r.lastSeen = Date.now();
      remotes[p.id] = r;
    });

    channel.on('broadcast', { event: 'chat' }, function (msg) {
      var p = msg.payload || {};
      if (p.id === myId) return; // don't echo our own
      chatCallbacks.forEach(function (cb) {
        try { cb({ id: p.id, name: p.name, text: p.text }); } catch (e) {}
      });
    });

    channel.subscribe(function (status) {
      if (status === 'SUBSCRIBED') {
        channelReady = true;
        channel.track({
          id: myId,
          name: myName,
          opts: loadAvatarOpts(),
          floor: floorKey,
          joinedAt: Date.now()
        });
      } else if (status === 'CLOSED' || status === 'CHANNEL_ERROR') {
        channelReady = false;
      }
    });
  }

  function stop() {
    if (!channel) return;
    channelReady = false;
    try { channel.unsubscribe(); } catch (e) {}
    try { sb.removeChannel(channel); } catch (e) {}
    channel = null;
    currentFloorKey = null;
    remotes = {};
  }

  function sendPosition(x, y, dir, anim) {
    if (!channel || !channelReady) return; // gate on SUBSCRIBED to avoid REST fallback
    var now = Date.now();
    if (now - lastPosSent < POS_THROTTLE) return;
    lastPosSent = now;
    channel.send({
      type: 'broadcast',
      event: 'pos',
      payload: { id: myId, x: Math.round(x), y: Math.round(y), dir: dir, anim: anim }
    });
  }

  function sendChat(text) {
    if (!channel || !channelReady) return false;
    var now = Date.now();
    if (now - lastChatSent < CHAT_RATE_LIMIT) return false;
    lastChatSent = now;
    var cleaned = clean(text);
    channel.send({
      type: 'broadcast',
      event: 'chat',
      payload: { id: myId, name: myName, text: cleaned }
    });
    return true;
  }

  function onChat(cb) { if (typeof cb === 'function') chatCallbacks.push(cb); }
  function getRemotes() { return remotes; }
  function getMyId() { return myId; }
  function getMyName() { return myName; }
  function setMyName(n) {
    if (!n) return;
    myName = String(n).slice(0, 32);
    localStorage.setItem('g95-mp-name', myName);
    if (channel) channel.track({ id: myId, name: myName, opts: loadAvatarOpts(), floor: currentFloorKey });
  }

  window.Galleria95MP = {
    enabled: true,
    start: start,
    stop: stop,
    sendPosition: sendPosition,
    sendChat: sendChat,
    onChat: onChat,
    getRemotes: getRemotes,
    getMyId: getMyId,
    getMyName: getMyName,
    setMyName: setMyName
  };
})();
